/**
 * Remember where the user was before we sent them to Cognito.
 *
 * Cognito always returns to a single registered redirect URI, and the signin
 * callback strips the query string, so a URL like
 * /checkout/complete?session_id=cs_123 would otherwise be lost — stranding a
 * buyer who paid but was signed out when they came back from Stripe.
 */

const STORAGE_KEY = 'postLoginRedirect';

export function rememberPostLoginDestination(destination: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, destination);
  } catch {
    // Private browsing or a full quota: losing the destination is survivable
  }
}

/**
 * Read and clear the stored destination.
 *
 * Only same-origin relative paths are returned, so a poisoned storage value
 * cannot turn the login flow into an open redirect.
 */
export function consumePostLoginDestination(): string | null {
  try {
    const destination = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);

    if (!destination) {
      return null;
    }

    if (!destination.startsWith('/') || destination.startsWith('//')) {
      return null;
    }

    return destination;
  } catch {
    return null;
  }
}
